import { useState, useEffect } from 'react';
import { apiFetch } from '../api';

function ActivityLog() {
  const [logs, setLogs] = useState([]);
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch('/api/activity-log/dates')
      .then((res) => res.json())
      .then((data) => {
        setDates(data);
        if (data.length > 0) setSelectedDate(data[0]);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    fetchLogs();
  }, [selectedDate]); // eslint-disable-line react-hooks/exhaustive-deps

  async function fetchLogs() {
    setLoading(true);
    try {
      const params = new URLSearchParams({ count: '500' });
      if (selectedDate) params.set('date', selectedDate);
      const res = await apiFetch(`/api/activity-log?${params}`);
      if (res.ok) setLogs(await res.json());
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  const filtered = categoryFilter === 'all'
    ? logs
    : logs.filter((l) => l.category === categoryFilter);

  const categories = [...new Set(logs.map((l) => l.category))];

  function formatTime(ts) {
    return new Date(ts).toLocaleString('en-US', {
      timeZone: 'America/Chicago',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short',
    });
  }

  async function exportToExcel() {
    try {
      const params = new URLSearchParams();
      if (selectedDate) params.set('date', selectedDate);
      const res = await apiFetch(`/api/activity-log/export?${params}`);
      if (res.ok) {
        const blob = await res.blob();
        const disposition = res.headers.get('content-disposition');
        const filename = disposition?.match(/filename=(.+)/)?.[1] || 'activity-log.csv';
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        a.click();
        URL.revokeObjectURL(a.href);
      }
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <section className="card settings-section">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2 style={{ margin: 0 }}>Activity Log</h2>
        <button className="manage-btn" onClick={exportToExcel} style={{ fontSize: 12 }}>Export to Excel</button>
      </div>
      <p className="settings-description">
        All external data fetches and data changes are logged here.
      </p>
      <div className="log-controls">
        <select
          className="log-select"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
        >
          <option value="">All Dates</option>
          {dates.map((d) => (
            <option key={d} value={d}>{d}</option>
          ))}
        </select>
        <select
          className="log-select"
          value={categoryFilter}
          onChange={(e) => setCategoryFilter(e.target.value)}
        >
          <option value="all">All Categories</option>
          {categories.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
        <span className="log-count">{filtered.length} entries</span>
      </div>
      {loading ? (
        <p className="loading">Loading logs...</p>
      ) : filtered.length === 0 ? (
        <p className="receipts-empty">No log entries found.</p>
      ) : (
        <div className="log-list">
          {filtered.map((log) => (
            <div key={log.id} className="log-entry">
              <div className="log-entry-header">
                <span className={`log-category ${log.category === 'External Fetch' ? 'log-cat-fetch' : 'log-cat-change'}`}>
                  {log.category}
                </span>
                <span className="log-time">{formatTime(log.timestamp)}</span>
              </div>
              <div className="log-entry-body">
                <span className="log-action">{log.action}</span>
                {log.detail && <span className="log-detail">{log.detail}</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export default ActivityLog;
